<template>
	<v-dialog v-model="dialog" persistent max-width="500px">
		<v-card>
			<v-form>
				<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">Convert Position to Template</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
                    <v-subheader class="text-xs-left mb-4 pl-0">Convert this position description into a reusable template. Once created, this template can be easily applied to any employee.</v-subheader>
					<v-text-field v-model="form.title" ref="title" :error-messages="titleErrors" label="Position Title" required @input="$v.form.title.$touch()" @blur="$v.form.title.$touch()"> </v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="closeDialog">Cancel</v-btn>
					<v-btn color="primary" flat :disabled="isSaving" :loading="isSaving" @click="convertPositionToTemplate">Save <span slot="loader">Saving...</span></v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
	import toast from '@/services/toasts/index.js';
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		props: {
			position: {
				type: Object,
				required: true
			},
			dialog: {
				type: Boolean,
				required: true
			}
		},
		data() {
			return {
				form: {
					title: this.position.title
				},
				isSaving: false
			};
		},
        mounted() {
			this.$nextTick(() => {
				this.$refs.title.focus();
			});
		},
		mixins: [validationMixin],
		validations: {
			form: {
				title: { required }
			}
		},
		computed: {
			titleErrors() {
				const errors = [];
				if (!this.$v.form.title.$dirty) return errors;
				!this.$v.form.title.required && errors.push('Position Title is required.');
				return errors;
			}
		},
		methods: {
			closeDialog() {
				this.$emit('closeDialog');
			},
			convertPositionToTemplate() {
				let positionTemplate = {
					id: this.newGuid(),
					title: this.form.title,
					description: this.position.description,
					department: { id: null, name: 'N/A' },
					positionItems: this.position.positionItems
				};

				this.isSaving = true;

				this.$store.dispatch('positionTemplates/add', positionTemplate).then(
					response => {
						this.$router.push({ name: 'positionTemplate', params: { id: response.id } });
						toast.success('Position Template Created');
						this.isSaving = false;
						this.closeDialog();
					},
					error => {
						toast.success('The Position Template could not be created at this time');
						this.isSaving = false;
					}
				);
			}
		}
	};
</script>
